
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { Rectangle, LineStyle, PaintStyle } from "../../../../domain/drawing";

@Component
export default class RectangleAreaDrawableMixin extends Mixins() {
  @Prop()
  rectangle: Rectangle;

  @Prop()
  borderStyle: LineStyle;

  @Prop()
  paintStyle: PaintStyle;

  @Emit()
  pointerdown(event: PointerEvent): void {}

  get rectangleStyles() {
    return {
      position: "absolute",
      top: this.rectangle.x + "px",
      left: this.rectangle.y + "px",
      width: this.rectangle.width + "px",
      height: this.rectangle.height + "px",
    };
  }

  get areaStyles() {
    return {
      backgroundColor: this.paintStyle.color.value,
      // TODO: texture対応.(必要になってから.)
      borderColor: this.borderStyle.color.value,
      borderWidth: this.borderStyle.width + "px",
      borderStyle: "solid", // TODO: kind対応.(必要になってから.)
    };
  }
}
